import { render, staticRenderFns } from "./french_alphabet.vue?vue&type=template&id=21a26cc6&scoped=true"
import script from "./french_alphabet.vue?vue&type=script&lang=js"
export * from "./french_alphabet.vue?vue&type=script&lang=js"
import style0 from "./french_alphabet.vue?vue&type=style&index=0&id=21a26cc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a26cc6",
  null
  
)

export default component.exports